import i18n from "i18next";

export const SUPPORTED_LANGUAGES = ["am", "en", "ru"];
export const LANGUAGE_OPTIONS = [
  { value: "am", code: "AM", label: "Հայերեն" },
  { value: "en", code: "EN", label: "English" },
  { value: "ru", code: "RU", label: "Русский" },
];

export function normalizeLanguage(value) {
  const language = String(value || "am")
    .trim()
    .toLowerCase()
    .split("-")[0];
  if (language === "hy") return "am";
  return SUPPORTED_LANGUAGES.includes(language) ? language : "am";
}

export function getIntlLocale(value) {
  return { am: "hy-AM", en: "en-US", ru: "ru-RU" }[normalizeLanguage(value)];
}

export function getSavedLanguage() {
  try {
    return normalizeLanguage(localStorage.getItem("language"));
  } catch {
    return "am";
  }
}

export function applyLanguage(value) {
  const language = normalizeLanguage(value);
  document.documentElement.lang = language === "am" ? "hy" : language;
  try {
    localStorage.setItem("language", language);
  } catch {
    // The selection still applies when storage is unavailable.
  }
  return language;
}

export function changeLanguage(value) {
  return i18n.changeLanguage(applyLanguage(value));
}
